import { inject } from '@angular/core';
import { SessionService } from '../services/session.service';


export const systemGuard = () => {
	const sessionService: SessionService = inject(SessionService)
	return SessionService.isPH(sessionService.username) || SessionService.isNIQ(sessionService.username);;
};
